module.exports = __webpack_public_path__ + "img/line-flow-allow.3a58b17c.svg";